type Role = 'agent' | 'lead' | 'admin';

interface TicketLike {
	assignee_id: string | null;
}

// Mirrors server enforcement: agents may only see tickets assigned to them on
// the board. Lead/admin see all queues. The server is the trust boundary;
// this is purely UX scoping.
export function scopeBoardTickets<T extends TicketLike>(tickets: T[], role: Role, userId: string): T[] {
	if (role !== 'agent') return tickets;
	return tickets.filter(t => t.assignee_id === userId);
}
